module.exports = __webpack_public_path__ + "static/media/wallpaper1.bd5d71af.jpg";